import * as React from "react";
import styled from "styled-components";
import { Alert } from "components/bootstrap";
const Row = styled.tr`
  cursor: default;

  && td {
    min-width: 50px;
    word-break: break-word;
    padding: 4px 5px 2px;
  }
`;
const NoticeCell = styled.td`
  padding: 4px 5px 2px;
`;
const NoticeContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`;
const NoticeAlert = styled(Alert)`
  margin: 0;
  width: 100%;
`;
const NoticeActions = styled.div`
  flex-shrink: 0;
  min-width: 40px;
`;
const MessageTableOverrideRow = ({ colSpan, notice, rowActions = void 0 }) => /* @__PURE__ */ React.createElement(Row, { className: "table-data-row" }, /* @__PURE__ */ React.createElement(NoticeCell, { colSpan }, /* @__PURE__ */ React.createElement(NoticeContent, null, /* @__PURE__ */ React.createElement(NoticeAlert, { compact: true }, notice), rowActions && /* @__PURE__ */ React.createElement(NoticeActions, null, rowActions))));
export default MessageTableOverrideRow;
